import type { UnitSystem } from "@/atoms/units";

const METERS_TO_FEET = 3.28084;
const KMH_TO_MPH = 0.621371;

/** Convert meters to display value based on unit system */
export function formatHeight(meters: number, system: UnitSystem): string {
  if (system === "imperial") {
    return `${(meters * METERS_TO_FEET).toFixed(1)} ft`;
  }
  return `${meters.toFixed(1)} m`;
}

/** Convert Celsius to display value based on unit system */
export function formatTemp(celsius: number, system: UnitSystem): string {
  if (system === "imperial") {
    return `${Math.round(celsius * 1.8 + 32)}°F`;
  }
  return `${Math.round(celsius)}°C`;
}

/** Convert km/h to display value based on unit system */
export function formatWindSpeed(kmh: number, system: UnitSystem): string {
  if (system === "imperial") {
    return `${Math.round(kmh * KMH_TO_MPH)} mph`;
  }
  return `${Math.round(kmh)} km/h`;
}

/** Height unit label for chart axes */
export function heightUnit(system: UnitSystem): string {
  return system === "imperial" ? "ft" : "m";
}

/** Convert meters to the numeric value in the chosen system */
export function convertHeight(meters: number, system: UnitSystem): number {
  return system === "imperial" ? meters * METERS_TO_FEET : meters;
}
